import React from "react";
import { CheckOutlined } from "@ant-design/icons";
import * as S from "./styles";

import userCheck from "../../assets/icons/user-check.png";
import userPlus from "../../assets/icons/user-plus.png";
import { formatClientName } from "../../utils/formatClientName";
import { formatCpf } from "../../utils/formatCpf";
import { ClientSelectionItemProps } from "./types";

export const ClientSelectionItem: React.FC<ClientSelectionItemProps> = ({
  client,
  isSelected,
  onSelect,
  className,
  infosToShow = {
    id: false,
    name: true,
    cpf: true,
    statusCliente: false,
  },
}) => {
  const { cpf, name, type, id } = client;
  const isTitular = type === "titular";
  const icon = isTitular ? userCheck : userPlus;
  const altText = `Ícone de portador ${isTitular ? "Titular" : "Dependente"}`;
  const title = isTitular ? "Titular" : "Dependente";

  return (
    <S.ItemContainer
      isSelected={isSelected}
      onClick={onSelect}
      data-testid={`conta_portador_${id}`}
      className={className}
      $hasSocialName={!!client?.nomeSocial}
    >
      <S.Title>
        <S.TitleIcon src={icon} alt={altText} />
        {title}
      </S.Title>
      {infosToShow.id && (
        <S.Info>
          <S.InfoLabel>ID: </S.InfoLabel>
          {id}
        </S.Info>
      )}
      {infosToShow.name && (
        <S.Info>
          <S.InfoLabel>Nome: </S.InfoLabel>
          {formatClientName(name)}
        </S.Info>
      )}

      {client?.nomeSocial && (
        <S.Info>
          <S.InfoLabel>Nome Social: </S.InfoLabel>
          {formatClientName(client?.nomeSocial)}
        </S.Info>
      )}

      {infosToShow.cpf && (
        <S.Info>
          <S.InfoLabel>CPF: </S.InfoLabel>
          {cpf ? formatCpf(cpf) : "CPF não disponível"}
        </S.Info>
      )}

      {isTitular && infosToShow.statusCliente && (
        <S.Info>
          <S.InfoLabel>Status: </S.InfoLabel>
          {client.statusCliente}
        </S.Info>
      )}

      <S.Checkmark isSelected={isSelected}>
        <CheckOutlined />
      </S.Checkmark>
    </S.ItemContainer>
  );
};
